import type { ReportQuery } from '@chukua/common';
import { useEffect, useState } from 'react';
import { getTrend, type ReportTrend } from '../reports.api';

export type ReportTrendState = { status: 'loading' } | { status: 'loaded'; trend: ReportTrend } | { status: 'error'; error: unknown };

/** The trend under the figures' filters. A failure is thrown by the caller to the route's error page, never drawn as an empty chart. */
export function useReportTrend(key: string, query: ReportQuery, enabled: boolean): ReportTrendState {
  const [state, setState] = useState<ReportTrendState>({ status: 'loading' });
  const filters = JSON.stringify({ ...query, page: 1, sort: 'label', order: 'asc' });

  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    getTrend(key, JSON.parse(filters) as ReportQuery)
      .then((trend) => {
        if (!cancelled) setState({ status: 'loaded', trend });
      })
      .catch((error: unknown) => {
        if (!cancelled) setState({ status: 'error', error });
      });
    return () => {
      cancelled = true;
    };
  }, [key, filters, enabled]);

  return state;
}
